class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.isClickMegaMenu = this.mainDetailsToggle.classList.contains('mega-menu--click');

    if (this.isClickMegaMenu) {
      this.summary = this.mainDetailsToggle.querySelector('summary');
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.contains(document.activeElement)) return;
      // Mega menú click: al pasar a otro item no se cierra aquí, sino cuando el otro abre (evita pestañeo)
      if (this.isClickMegaMenu && document.activeElement?.closest('header-menu .mega-menu--click')) return;
      this.close();
    });
  }

  // Mega menú click: intercepta el toggle nativo para poder animar el cierre y cambiar de menú sin pestañeo.
  onSummaryClick(event) {
    const details = this.mainDetailsToggle;

    if (details.open && !details.classList.contains('is-closing')) {
      event.preventDefault();
      this.close();
      return;
    }

    if (details.classList.contains('is-closing')) {
      // Reabrir durante la animación de cierre: se revierte sin cerrar.
      event.preventDefault();
      this.cancelClosing();
      details.classList.add('is-switching');
      // Se difiere para quedar después del listener de global.js que también actualiza aria-expanded.
      setTimeout(() => this.summary.setAttribute('aria-expanded', true));
      return;
    }

    const openMenus = this.getOtherOpenMenus();
    if (openMenus.length) {
      // Cambio entre menús: el nuevo aparece sin animación de entrada y el anterior se cierra al instante.
      details.classList.add('is-switching');
      openMenus.forEach((menu) => menu.close({ instant: true }));
    }
  }

  getOtherOpenMenus() {
    return [...document.querySelectorAll('header-menu')].filter(
      (menu) => menu !== this && menu.mainDetailsToggle.open
    );
  }

  close({ instant = false } = {}) {
    const details = this.mainDetailsToggle;
    if (!this.isClickMegaMenu || !details.open) return super.close();

    this.summary.setAttribute('aria-expanded', false);

    if (instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.finishClosing();
      return;
    }

    if (details.classList.contains('is-closing')) return;

    details.classList.remove('is-switching');
    details.classList.add('is-closing');

    this.onClosingEnd = (event) => {
      if (event && event.target !== this.content) return;
      this.finishClosing();
    };
    this.content.addEventListener('animationend', this.onClosingEnd);
    // Respaldo por si la animación no llega a dispararse (p. ej. pestaña en segundo plano).
    this.closingTimeout = setTimeout(this.onClosingEnd, 400);
  }

  cancelClosing() {
    clearTimeout(this.closingTimeout);
    if (this.onClosingEnd) this.content.removeEventListener('animationend', this.onClosingEnd);
    this.onClosingEnd = null;
    this.mainDetailsToggle.classList.remove('is-closing');
  }

  finishClosing() {
    this.cancelClosing();
    this.mainDetailsToggle.classList.remove('is-switching');
    this.mainDetailsToggle.removeAttribute('open');
  }

  onToggle() {
    if (this.isClickMegaMenu) {
      if (this.mainDetailsToggle.open) {
        this.getOtherOpenMenus().forEach((menu) => menu.close({ instant: true }));
      } else {
        // Cierre externo (p. ej. Escape): limpia estados de animación.
        this.cancelClosing();
        this.mainDetailsToggle.classList.remove('is-switching');
      }
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
